import styled from 'styled-components';

import { Box } from '../../../common/ui/Box';

export const IconWrapper = styled(Box)`
    align-items: center;
    color: inherit;
    display: flex;
    height: 20px;
    justify-content: center;
    pointer-events: none;
    width: 20px;
`;
